import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import { Pagination } from "@mui/material";
import MobileNavbar from "examples/Navbars/MobileNavbar";
import { useIsMobile } from "hooks/useIsMobile";
import TotalsView from "components/totals_view";
import { getPaymentSummaryCall } from "api/api";
import getPaymentSummaryTableData from "./data/table_data";
const limit = 8;

function PaymentSummary() {
  const [state, setState] = useState({
    columns: [],
    rows: [],
    page: 1,
    totalPages: 1,
    totalNotSettledAmount: "",
  });

  const isMobile = useIsMobile();

  const getPaymentSummary = async ({ page }) => {
    const response = await getPaymentSummaryCall({ page, limit });
    if (response) {
      const { totalNotSettledAmount, page } = response;
      const { columns, rows } = getPaymentSummaryTableData(response.data);
      setState({
        ...state,
        columns,
        rows,
        page,
        totalPages: response.total_pages,
        totalNotSettledAmount,
      });
    }
  };

  useEffect(() => {
    const { page } = state;
    getPaymentSummary({ page });
  }, [state.page]);

  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems={isMobile ? "left" : "center"}
                flexDirection={isMobile ? "column" : "row"}
                gap={isMobile ? 1 : 0}
              >
                <MDTypography variant="h6" color="white">
                  Payment Summary
                </MDTypography>
                <MDBox display="flex" flexDirection={isMobile ? "column" : "row"} gap={1}>
                  <TotalsView
                    title={"Not Settled"}
                    amount={state.totalNotSettledAmount}
                    variant="error"
                  />
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: state.columns, rows: state.rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <Pagination
                  style={{
                    justifySelf: "right",
                    margin: 10,
                  }}
                  variant="outlined"
                  shape="rounded"
                  count={state.totalPages}
                  page={state.page}
                  onChange={(e, page) => {
                    setState({ ...state, page });
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default PaymentSummary;
